import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const DefaultStepMetaOverrideSet = buildFacetDesignOverride();

export default DefaultStepMetaOverrideSet;
